export class EmploymentStatus {
  public id?: string;
  public name: string;
}
